module.exports = __webpack_public_path__ + "static/media/IMG_3069.01c60143.JPG";